import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { Modal } from "../../common/Modal";
import * as actions from "../redux/SubAgentAction";

export const UpdateSubAgentPermission = ({ setSwalProps, agentId }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const dismissBtnRef = useRef();
  const subAgentState = useSelector(({ subAgent }) => subAgent, shallowEqual);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const queryParams = {
      action: "subagentpermissionlist",
      selagentid: agentId,
    };
    dispatch(actions.subAgentPermissionList(queryParams));
  }, [agentId]);

  useEffect(() => {
    if (subAgentState.subAgentPermissionList?.subAgentPermissionLists) {
      setPermissions(
        subAgentState.subAgentPermissionList.subAgentPermissionLists
      );
    }
  }, [subAgentState.subAgentPermissionList]);

  const handleCheckBoxChange = (permissioncode) => {
    const queryParams = {
      action: "updatesubagentpermission",
      selagentid: agentId,
      permissioncode,
    };

    dispatch(actions.updateSubAgentPermission(queryParams)).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        const queryParams = {
          action: "subagentpermissionlist",
          selagentid: agentId,
        };
        dispatch(actions.subAgentPermissionList(queryParams));
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal
        modalId="updateSubAgentPermissionModal"
        title={intl.formatMessage({ id: "updateSubAgentPermission" })}
        dismissBtnRef={dismissBtnRef}
      >
        <div className="pb-2">
          {subAgentState.subAgentPermissionList &&
          subAgentState.subAgentPermissionList.subAgentPermissionLists ? (
            permissions.map((agent, index) => (
              <div key={index} className="subAgentPermission">
                <input
                  type="checkbox"
                  checked={agent.allow === "true"}
                  onChange={(e) => handleCheckBoxChange(agent.permissioncode)}
                  style={{
                    marginRight: "2vh",
                    width: "2vh",
                    height: "2vh",
                  }}
                />
                <span>{agent.description}</span>
              </div>
            ))
          ) : (
            <Skeleton height="600px" className="w-100" />
          )}
        </div>
      </Modal>
    </div>
  );
};
